import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// The CX registers (AINM and Customer Complaints). They are kept in SharePoint
// and mirrored hourly into the tech server, which is what these read.

export function useCxRegister(register) {
  return useQuery({
    queryKey: ['cx-register', register],
    queryFn: async () => (await api.get(`/api/cx-registers/${register}`)).data,
    staleTime: 60000,
  });
}

export function useCxPins(register) {
  return useQuery({
    queryKey: ['cx-register', register, 'pins'],
    queryFn: async () => (await api.get(`/api/cx-registers/${register}/pins`)).data,
    staleTime: 60000,
  });
}

// Only fetched when a record is opened — it carries every SharePoint column,
// which is far more than the list needs.
export function useCxRecord(register, id) {
  return useQuery({
    queryKey: ['cx-register', register, 'record', id],
    queryFn: async () => (await api.get(`/api/cx-registers/${register}/${id}`)).data,
    enabled: Boolean(id),
    staleTime: 60000,
  });
}

// Pull from SharePoint now rather than waiting for the hourly sync at :40.
export function useSyncCxRegisters() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post('/api/cx-registers/sync')).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['cx-register'] }),
  });
}
